import { render, staticRenderFns } from "./demo3.vue?vue&type=template&id=2071a4f4&"
import script from "./demo3.vue?vue&type=script&lang=ts&"
export * from "./demo3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports